import { Button } from "primereact/button";
import React, { useMemo, useRef } from "react";
import styled from "styled-components";
import useBreakpoint from "../../WSUtils/useBreakpoint";
import { concatClassnames } from "../../WSUtils/util";
import { WSFormGrid } from "../../WSUtils/WSFormGrid";
import { StepsProps } from "./Step";

export const Steps = ({
  steps,
  value: currentStep,
  onChange,
  className,
}: StepsProps) => {
  const currentIndex = steps.findIndex((s) => s.value === currentStep.value);

  // measuring body instead of local div to prevent layoutshift
  const containerRef = useRef<HTMLElement>(document.body);
  const wideLayout = useBreakpoint(containerRef, (width) => width >= 480);

  return (
    <Styles
      className={concatClassnames([
        "cvp-button-stepper",
        !!wideLayout && "cvp-button-stepper-wide-layout",
        className,
      ])}
      float
    >
      {steps.map((step, index) => {
        const active = index === currentIndex;

        return (
          <Button
            className={concatClassnames([
              active && "p-button-primary",
              !active && "p-button-secondary",
              "cvp-step-button",
              `cvp-step-button-${index + 1}`,
              active && "cvp-step-button-active",
              !active && "p-button-outlined",
            ])}
            data-step={index + 1}
            key={step.value}
            onClick={(evt) => {
              evt.preventDefault();
              onChange(evt, step);
              return false;
            }}
          >
            <span className="cvp-step-button-number">{index + 1}</span>
            <span className="cvp-step-button-text">{step.label}</span>
          </Button>
        );
      })}
    </Styles>
  );
};

const Styles = styled(WSFormGrid)`
  &.cvp-button-stepper {
    .cvp-step-button {
      height: 40px;
    }

    .cvp-step-button-active.cvp-step-button-active {
      border-color: transparent;
      transition-property: box-shadow;
    }
  }
`;
